/**
 * @desc  AttendancesService class.
 * @ngInject
 */
export default class AttendanceService {
  /**
   * Constructor of the class.
   *
   * @param {$rootScope} $rootScope
   * @param {$q} $q
   * @param {$log}  $log
   * @param {$http} $http
   */
  constructor(
    $rootScope, $q, $log, $http
  ) {
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$log = $log;
    this.$http = $http;

    this.attendancesByClassRoom = [];

    this.$rootScope.$on('scr.select', () => {
      this.attendancesByClassRoom.splice(0, this.attendancesByClassRoom.length);
    });
  }

  get(studentId, id) {
    return this.$http({
      method: 'GET',
      url: `/SCR/student/${studentId}/attendance/${id}`
    }).then(result => {
      const attendance = result.data.attendance[0];
      const copyAttendance = {};
      angular.copy(attendance, copyAttendance);
      if (!attendance.invalid) {
        attendance.color = '#8BC34A';
      }

      attendance.start = attendance.date + ' ' + attendance.startTime;
      if (attendance.endTime) {
        attendance.end = attendance.date + ' ' + attendance.endTime;
        attendance.title = copyAttendance.startTime.slice(0, -3) + ' - ' + copyAttendance.endTime.slice(0, -3);
      } else {
        attendance.allDay = true;
        attendance.color = '#FFEB3B';
        attendance.title = copyAttendance.startTime.slice(0, -3) + ' - ...';
        attendance.textColor = '#212121';
      }

      const attendances = [attendance];
      return attendances;
    }, err => this.$q.reject(err));
  }

  getByClassRoom(params = {}) {
    return this.$http({
      method: 'GET',
      url: `/SCR/classRoom/${params.id}/attendance`,
      params: {date: params.date, startTime: params.startTime, endTime: params.endTime}
    }).then(result => {
      this.attendancesByClassRoom = result.data.attendances;
      if (this.attendancesByClassRoom.length > 0) {
        this.attendancesByClassRoom.forEach(attendance => {
          attendance.start = attendance.date + ' ' + attendance.startTime;
          if (attendance.endTime) {
            attendance.end = attendance.date + ' ' + attendance.endTime;
          }
        });
      }

      return this.attendancesByClassRoom;
    }, err => this.$q.reject(err));
  }

  getRegistrations(options = {}) {
    return this.$http({
      method: 'GET',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/attendances/registrations`,
      params: {
        employeeId: options.employeeId,
        tagId: options.tagId,
        groupId: options.groupId,
        classRoomId: options.classRoomId,
        day: options.day,
        studentId: options.studentId
      },
      ignoreLoadingBar: !options.showLoaderSpinner
    }).then(result => {
      this.allAttendanceRegistrations = result.data.attendances;
      return this.allAttendanceRegistrations;
    }, err => this.$q.reject(err));
  }

  destroy(identifiers) {
    return this.$http({
      method: 'DELETE',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/attendances`,
      params: {identifiers}
    }).then(() => this.$q.resolve(), err => this.$q.reject(err));
  }
}
